/* istanbul ignore file */
import { UntypedFormGroup } from '@angular/forms';
import { App, FilterMenuOptions, Project } from '../../../../models';
import { Field } from '../field';

export class MapFilterSelectionModel {
    mapFiltersForm: UntypedFormGroup;
    id?: string;
    isLoading = false;
    projectId: string;
    mapFilterMenuOptions: FilterMenuOptions;
    availableFields: Field[];
    previousApp: App;
    previousProject: Project;
}
